/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_SpottingInputs */



/**
* | output |
* | --- |
* | "SPOTTING" |
*
* @param {Ccsl_Export_Header_SpottingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_spotting = /** @type {((inputs?: Ccsl_Export_Header_SpottingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_SpottingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("REPERAGE")
	if (locale === "de") return /** @type {LocalizedString} */ ("SPEKTIEREN")
	if (locale === "it") return /** @type {LocalizedString} */ ("AVVISTAMENTO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("НАБЛЮДЕНИЕ")
	if (locale === "es") return /** @type {LocalizedString} */ ("PUNTEO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发现")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スポッティング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोलना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AVISTAMENTO")
	return /** @type {LocalizedString} */ ("SPOTTING")
});